export var fieldContainerDefaultProps = {
  dataSpacer: "",
  className: "",
  hasError: false,
  isDisabled: false,
  tag: "fieldset"
};
export var fieldLabelDefaultProps = {
  className: "",
  required: true,
  isDisabled: false,
  notRequiredText: "",
  dataSpacerLabel: ""
};
export var fieldWrapperDefaultProps = {
  className: "",
  dataSpacer: ""
};
export var fieldIconDefaultProps = {
  onIconClick: null,
  className: "",
  hasIconOnLeft: false,
  isDisabled: false
};
export var fieldSwitchTextDefaultProps = {
  hasError: false,
  className: "",
  helpText: "",
  errorText: ""
};
export var fieldLayoutDefaultProps = {
  commonProps: {
    hasError: false
  },
  containerProps: {},
  labelProps: {},
  fieldWrapperProps: {},
  iconProps: {},
  switchTextProps: {}
};